import { render } from "./PrinterSettingsCard.vue?vue&type=template&id=77bb6d3d"
import script from "./PrinterSettingsCard.vue?vue&type=script&lang=js"
export * from "./PrinterSettingsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__